import * as React from 'react';
import ChevronLeftOutlined from './chevron-left-outlined';
import ChevronLeftFilled from './chevron-left-filled';
import type { IconCombinedProps } from './types';
const ChevronLeftCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <ChevronLeftFilled ref={ref} {...rest} />;
  }
  return <ChevronLeftOutlined ref={ref} {...rest} />;
});
export default ChevronLeftCombined;